import { createStore } from 'vuex'
import axios from 'axios'
import { Capacitor } from '@capacitor/core'

const token = localStorage.getItem('token') || ''
//const lega_attiva  = localStorage.getItem('lega_attiva') || ''

if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Nell'app nativa (Capacitor) la pagina gira su un origin locale del webview
// (capacitor://localhost su iOS, http://localhost su Android), non sul dominio
// reale: window.location.origin li' non punterebbe mai al backend vero, quindi
// va sempre forzato il dominio di produzione quando l'app gira come nativa,
// indipendentemente da NODE_ENV (il build per l'app e' comunque un build
// "production" di Vue CLI).
const isNative = Capacitor.isNativePlatform()

export default createStore({
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '1.0.0',
    status: '',
    token: token,
    //lega_attiva :lega_attiva,
    user: JSON.parse(localStorage.getItem('user')) || '',
    classe: '',
    controller: isNative
      ? 'https://fantapremier.alwaysdata.net/controller/Controller.php'
      : process.env.NODE_ENV === 'development'
        ? 'http://localhost:8002/controller/controller.php'
        //: '/controller/Controller.php',
        : `${window.location.origin}/controller/Controller.php`,
    refresh: false,
    drawer: true,
  },

  getters: {
    appVersion: (state) => state.packageVersion,
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    getToken: (state) => state.token,
    getUser: (state) => state.user,
    getLega:(state) => state.lega_attiva,
    isAuthenticated: (state) => !!state.token
  },

  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, { token, user }) {
      state.status = 'success'
      state.token = token
      state.user = user
      
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = ''
    },
    updateLegaAttiva(state, { nomeLega, idLegaAttiva }) {
    state.user = {
      ...state.user,
      nome_lega: nomeLega,
      lega_attiva: idLegaAttiva
    }
    localStorage.setItem('user', JSON.stringify(state.user))
  }
  },

  actions: {
    login({ commit, state }, userData) {
      return new Promise((resolve, reject) => {
        commit('auth_request')

        axios.post(state.controller, {
          params: {
            ...userData,
            action: 'login'
          }
        })
        .then(resp => {
          if (!resp.data.success) {
            throw new Error(resp.data.message)
          }
          //console.log(resp.data)
          const token = resp.data.data.token
          const user = resp.data.data.user

          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

          commit('auth_success', { token, user })
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          delete axios.defaults.headers.common['Authorization']
          reject(err)
        })
      })
    },

    logout({ commit }) {
      return new Promise(resolve => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },

  modules: {}
})
